import type { View } from '../App';
import { useI18n, type Locale } from '../i18n';

const NAV_ITEMS: { id: View; labelKey: string; icon: string }[] = [
  { id: 'dashboard', labelKey: 'nav.dashboard', icon: '◎' },
  { id: 'inbox', labelKey: 'nav.inbox', icon: '⌗' },
  { id: 'daily', labelKey: 'nav.daily', icon: '◷' },
  { id: 'decision', labelKey: 'nav.decision', icon: '◇' },
];

export function Sidebar({ current, onChange }: { current: View; onChange: (v: View) => void }) {
  const { t, locale, setLocale } = useI18n();

  return (
    <aside className="sidebar">
      <div className="sidebar-brand">
        <div className="sidebar-brand-logo" />
        <div>
          <div className="sidebar-brand-name">{t('brand.name')}</div>
          <div className="sidebar-brand-tag">{t('brand.tagline')}</div>
        </div>
      </div>
      {NAV_ITEMS.map((n) => (
        <button
          key={n.id}
          className={`nav-item ${current === n.id ? 'active' : ''}`}
          onClick={() => onChange(n.id)}
        >
          <span className="nav-icon">{n.icon}</span>
          {t(n.labelKey)}
        </button>
      ))}

      <div className="lang-toggle" role="group" aria-label={t('lang.toggle.label')}>
        {(['ru', 'en'] as Locale[]).map((l) => (
          <button
            key={l}
            className={`lang-pill ${locale === l ? 'active' : ''}`}
            onClick={() => setLocale(l)}
            type="button"
          >
            {l.toUpperCase()}
          </button>
        ))}
      </div>

      <div className="sidebar-footer">
        {t('brand.footer').split('\n').map((line, i) => (
          <span key={i}>
            {line}
            <br />
          </span>
        ))}
      </div>
    </aside>
  );
}
